import { Directive, EventEmitter, Input, OnInit, Output } from '@angular/core';

/**
 * Lightweight replacement for the unmaintained `angular2-counto` directive.
 * Skips the count-up animation and immediately emits the final value so existing
 * templates that bind to `[countTo]` and `(countoChange)` keep working.
 */
@Directive({
    standalone: false,
    selector: '[counto]'
})
export class CountoStubDirective implements OnInit {
    @Input() step = 1;
    @Input() duration = 1;
    @Input() countFrom: any = 0;
    @Input() countTo: any = 0;
    @Output() countoChange = new EventEmitter<any>();
    @Output() countoEnd = new EventEmitter<void>();

    ngOnInit(): void {
        this.countoChange.emit(this.countTo);
        this.countoEnd.emit();
    }
}
